import { __assign } from "tslib";
import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import omitBy from 'lodash/omitBy';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import CheckIcon from '../../../../Icons/Check';
import { IconSize } from '../../../../Icons/IconWrap';
import StandardMenuItemLabel from '../StandardMenuItemLabel';
import StandardMenuSubmenu from '../StandardMenuSubmenu';
import s from './StandardMenuOption.scss';
var StandardMenuOption = function (_a) {
    var id = _a.id, item = _a.item, _b = _a.item, itemIcon = _b.icon, iconClassName = _b.iconClassName, onClick = _b.onClick, onMouseEnter = _b.onMouseEnter, disabled = _b.disabled, danger = _b.danger, itemClassName = _b.className, value = _b.value, highlighted = _b.highlighted, selected = _b.selected, label = _b.label, biData = _b.biData, tabIndex = _b.tabIndex, link = _b.link, target = _b.target, title = _b.title, submenu = _b.submenu, subMenuPreferredSide = _b.subMenuPreferredSide, estimatedSubmenuWidth = _b.estimatedSubmenuWidth, minimumHeightNeededForSubmenu = _b.minimumHeightNeededForSubmenu, hideCheckIcon = _a.hideCheckIcon, withHoverEffect = _a.withHoverEffect, className = _a.className, focused = _a.focused;
    var icon = null;
    if (itemIcon) {
        // ick
        icon = React.cloneElement(itemIcon, {
            className: classnames(s['menu-item-icon'], iconClassName),
        });
    }
    var itemRef = useRef(null);
    useEffect(function () {
        if (itemRef.current && focused) {
            itemRef.current.focus({ preventScroll: true });
        }
    }, [itemRef, focused]);
    var content = (React.createElement(React.Fragment, null,
        icon,
        React.createElement(StandardMenuItemLabel, { item: item }),
        selected && !hideCheckIcon && (React.createElement(CheckIcon, { className: s['selected-icon'], size: IconSize.TINY }))));
    // omitBy to prevent undefined values from overwriting props that we need.
    var sharedProps = omitBy({
        id: id,
        innerRef: function (node) {
            itemRef.current = node;
        },
        className: classnames(s['menu-item'], onClick && s['clickable'], disabled && s['disabled'], danger && s['danger'], withHoverEffect && s['with-hover-effect'], highlighted && s['highlighted'], itemClassName, className),
        value: value,
        disabled: disabled,
        selected: selected,
        label: typeof label === 'string' ? label : undefined,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        biData: biData,
        'data-selected': selected ? 'selected' : undefined,
        // We don't want to tab into items individually, the wrapping StandardMenuContent will manage
        // focus itself.
        tabIndex: tabIndex === undefined ? -1 : tabIndex,
        children: content,
        title: title,
    }, function (keyValue) { return keyValue === undefined; });
    if (link) {
        return (React.createElement(BiLink, __assign({ role: "option", "aria-selected": selected, href: link, target: target }, sharedProps)));
    }
    else if (submenu) {
        // A11Y TODO: Figure out what role these should have
        // Should likely be `role="option"` with an `aria-haspopup`
        // https://www.digitala11y.com/option-role/
        return (React.createElement(StandardMenuSubmenu, __assign({ submenu: submenu, preferredSide: subMenuPreferredSide, estimatedSubmenuWidth: estimatedSubmenuWidth, minimumHeightNeeded: minimumHeightNeededForSubmenu }, sharedProps)));
    }
    else {
        return (React.createElement("span", { role: "option", "aria-selected": selected },
            React.createElement(PlainButtonOrLink, __assign({ isFakeButton: true }, sharedProps))));
    }
};
StandardMenuOption.displayName = 'StandardMenuOption';
export default StandardMenuOption;
//# sourceMappingURL=StandardMenuOption.js.map